import React from 'react';
import Class11and12Factoryvisit2024 from 'views/Class11and12Factoryvisit2024';
const VissionAndMissionPage = () => {
  return <Class11and12Factoryvisit2024/>;
};

export default VissionAndMissionPage;